import type { AppLocale } from './locales';

export type BlogI18n = {
  breadcrumbHome: string;
  breadcrumbBlog: string;
  minRead: string;
  previous: string;
  next: string;
  tableOfContents: string;
  relatedArticles: string;
  readArticle: string;
  searchPlaceholder: string;
  noResults: string;
  clearSearch: string;
  sortNewest: string;
  sortOldest: string;
  featured: string;
  allArticles: string;
  articleFound: string;
  articlesFound: string;
  of: string;
  article: string;
  articles: string;
  ctaText: string;
  ctaButton: string;
  previousPage: string;
  nextPage: string;
};

export const BLOG_I18N: Record<AppLocale, BlogI18n> = {
  pt: {
    breadcrumbHome: 'Início',
    breadcrumbBlog: 'Blog',
    minRead: 'min de leitura',
    previous: 'Anterior',
    next: 'Próximo',
    tableOfContents: 'Conteúdo',
    relatedArticles: 'Artigos relacionados',
    readArticle: 'Ler artigo →',
    searchPlaceholder: 'Buscar artigos...',
    noResults: 'Nenhum artigo encontrado.',
    clearSearch: 'Limpar busca',
    sortNewest: 'Mais recentes',
    sortOldest: 'Mais antigos',
    featured: 'Em destaque',
    allArticles: 'Todos os artigos',
    articleFound: 'artigo encontrado',
    articlesFound: 'artigos encontrados',
    of: 'de',
    article: 'artigo',
    articles: 'artigos',
    ctaText: 'Tem alguma dúvida jurídica?',
    ctaButton: 'Fale conosco →',
    previousPage: 'Página anterior',
    nextPage: 'Próxima página',
  },
  en: {
    breadcrumbHome: 'Home',
    breadcrumbBlog: 'Blog',
    minRead: 'min read',
    previous: 'Previous',
    next: 'Next',
    tableOfContents: 'Contents',
    relatedArticles: 'Related articles',
    readArticle: 'Read article →',
    searchPlaceholder: 'Search articles...',
    noResults: 'No articles found.',
    clearSearch: 'Clear search',
    sortNewest: 'Newest',
    sortOldest: 'Oldest',
    featured: 'Featured',
    allArticles: 'All articles',
    articleFound: 'article found',
    articlesFound: 'articles found',
    of: 'of',
    article: 'article',
    articles: 'articles',
    ctaText: 'Have a legal question?',
    ctaButton: 'Get in touch →',
    previousPage: 'Previous page',
    nextPage: 'Next page',
  },
};
